import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'images'
const verb = HttpMethod.POST

export default class OspreyImagesShareToSilos extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425b4'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    shareToSilos(params) {
        const { imageId, siloIdList } = params

        this.path = `/${resource}/${imageId}/share/silos`

        this.params = {
            siloIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-silos-share.js